var form = require('./form.ejs');
var builder = require('./builder.ejs');

export default { form, builder };